<template>
	<div>
		<!-- Case -->
		<template v-if="genericViewId === 'case'">
			<slot name="case" :setViewId="setViewId" />
		</template>

		<!-- Proposals list -->
		<template v-else-if="genericViewId === 'proposals'">
			<slot name="proposals" :setViewId="setViewId" />
		</template>

		<!-- Proposal Detail -->
		<template v-else-if="genericViewId === 'proposal'">
			<slot name="proposal" :setViewId="setViewId" />
		</template>

		<!-- Offer Detail -->
		<template v-else-if="genericViewId === 'offer'">
			<slot name="offer" :setViewId="setViewId" />
		</template>
	</div>
</template>

<script>
export default {
	data() {
		return {
			genericViewId: "" // "case", "proposal", "proposals", "offer"
		}
	},

	methods: {
		setViewId({ viewId, proposalId = null, offerId = null }) {
			this.genericViewId = viewId

			if (proposalId)
				this.$store.commit("caseManagement/SET_PROPOSAL_ID", proposalId)

			if (offerId) this.$store.commit("caseManagement/SET_OFFER_ID", offerId)

			// Update router
			this.$router.push({
				query: {
					genericViewId: viewId
				}
			})
		}
	},

	mounted() {
		// Set initial state
		this.$router.replace({
			query: {
				genericViewId: "case"
			}
		})
	},

	watch: {
		$route: {
			handler() {
				this.genericViewId = this.$route.query?.genericViewId
			},
			immediate: true
		}
	}
}
</script>
